import { useQuery } from "@tanstack/react-query";
import { gql } from "../api/graphql.js";
import { COMPANIES_QUERY } from "../api/queries.js";

export interface Company {
  id: string;
  slug: string;
  name: string;
  display_order: number;
}

interface Resp {
  companies: Company[];
}

export function useCompanies() {
  return useQuery({
    queryKey: ["companies"],
    queryFn: async () => {
      const data = await gql.request<Resp>(COMPANIES_QUERY);
      return data.companies;
    },
  });
}
